import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '@shared/ui/modal';
import { Observable, from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(private ngbModal: NgbModal) {}

  openConfirmModal(title: string, body: string): Observable<boolean> {
    const modalInstance = this.ngbModal.open(ConfirmModalComponent);
    modalInstance.componentInstance.title = title;
    modalInstance.componentInstance.body = body;

    return from(
      modalInstance.result.then(
        () => true,
        () => false
      )
    );
  }

  closeAllModals(): void {
    this.ngbModal.dismissAll();
  }
}
